import { render, staticRenderFns } from "./InvestorTable.vue?vue&type=template&id=680d7b40&scoped=true&"
import script from "./InvestorTable.vue?vue&type=script&lang=js&"
export * from "./InvestorTable.vue?vue&type=script&lang=js&"
import style0 from "./InvestorTable.vue?vue&type=style&index=0&id=680d7b40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d7b40",
  null
  
)

export default component.exports